@if (!mode || mode === 'default' || mode === 'compact') {
  <div
    class="info-block"
  [ngClass]="{
    'info-block--info': !status || status === 'info',
    'info-block--warning': status === 'warning',
    'info-block--error': status === 'error',
    'info-block--compact': mode === 'compact',
  }"
    >
    <div class="info-icon">
      @if (!status || status === 'info') {
        <i
          class="fa-light fa-circle-info"
          aria-hidden="true"
          [attr.title]="'COMPONENT.INFORMATION_BLOCK_ICONS.INFO_ICON' | translate"
          ><span class="screen-reader-only">Info icon</span></i
          >
        }
        @if (status === 'warning') {
          <i
            class="fa-light fa-triangle-exclamation"
            aria-hidden="true"
            [attr.title]="'COMPONENT.INFORMATION_BLOCK_ICONS.WARNING_ICON' | translate"
            ><span class="screen-reader-only">Warning icon</span></i
            >
          }
          @if (status === 'error') {
            <i
              class="fa-light fa-triangle-exclamation"
              aria-hidden="true"
              [attr.title]="'COMPONENT.INFORMATION_BLOCK_ICONS.ERROR_ICON' | translate"
              ><span class="screen-reader-only">Error icon</span></i
              >
            }
          </div>
          <div class="text-content">
            <p>
              {{ displayedText | translate }}
              @if (hasToggle) {
                <span
                  class="read-more"
                  (click)="toggle()"
                  >
                  {{ (expanded ? 'INFORMATION_BLOCK_BTN.HIDE' : 'INFORMATION_BLOCK_BTN.READ_MORE') | translate }}
                </span>
              }
            </p>
          </div>
        </div>
      }

      @if (mode && (mode === 'bubble' || mode === 'bubble-inline')) {
        <div
          class="info-bubble"
  [ngClass]="{
    'info-bubble--info': !status || status === 'info',
    'info-bubble--warning': status === 'warning',
    'info-bubble--error': status === 'error',
    'info-bubble--inline': mode === 'bubble-inline'
  }"
          >
          <div class="info-bubble__icon-container">
            @if (!status || status === 'info') {
              <i
                class="fa-light fa-circle-info"
                aria-hidden="true"
                [attr.title]="'COMPONENT.INFORMATION_BLOCK_ICONS.INFO_ICON' | translate"
                ><span class="screen-reader-only">{{ 'COMPONENT.INFORMATION_BLOCK_ICONS.INFO_ICON' | translate }}</span></i
                >
              }
              @if (status === 'warning') {
                <i
                  class="fa-light fa-triangle-exclamation"
                  aria-hidden="true"
                  [attr.title]="'COMPONENT.INFORMATION_BLOCK_ICONS.WARNING_ICON' | translate"
                  ><span class="screen-reader-only">{{ 'COMPONENT.INFORMATION_BLOCK_ICONS.WARNING_ICON' | translate }}</span></i
                  >
                }
                @if (status === 'error') {
                  <i
                    class="fa-light fa-triangle-exclamation"
                    aria-hidden="true"
                    [attr.title]="'COMPONENT.INFORMATION_BLOCK_ICONS.ERROR_ICON' | translate"
                    ><span class="screen-reader-only">{{ 'COMPONENT.INFORMATION_BLOCK_ICONS.ERROR_ICON' | translate }}</span></i
                    >
                  }
                </div>
                <div class="info-bubble__text-content">
                  {{ displayedText | translate  }}
                  @if (hasToggle) {
                    <span
                      class="read-more"
                      (click)="toggle()"
                      >
                      {{ (expanded ? 'INFORMATION_BLOCK_BTN.HIDE' : 'INFORMATION_BLOCK_BTN.READ_MORE') | translate }}
                    </span>
                  }
                </div>
              </div>
            }
